import React, { useState, useEffect, memo } from "react";
import {
    List,
    ListItemButton,
    ListItemText,
    Collapse,
    Typography,
    Container,
    Grid,
    Paper,
    Box,
    Divider,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import * as Styles from "./styles";

export const FaqCollapsible = memo(({ ref, faqData }) => {
    const [open, setOpen] = useState(null);
    const handleOpen = (e, index) => {
        if (open === index) {
            setOpen(null);
            return;
        }
        setOpen(index);
    };

    if (faqData && Object.keys(faqData).length === 0 && Object.getPrototypeOf(faqData) === Object.prototype) {
        return <></>;
    }

    return (
        <Container maxWidth="md" id="faqContainer" sx={Styles.centerBox}>
            <Paper
                sx={{
                    marginTop: "68px",
                    paddingTop: {
                        xs: 1,
                    },
                    width: "100%",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                }}
            >
                <Grid container>
                    <Grid item xs="12" sx={Styles.centerBox}>
                        <Typography
                            sx={{ marginBottom: 2.5 }}
                            align="center"
                            variant={"h4"}
                            htmlFor="questionnairesList"
                            tabIndex="0"
                        >
                            FAQ
                        </Typography>
                    </Grid>
                    <Grid item xs="12" sx={Styles.centerBox}>
                        <List
                            sx={{ width: "100%", bgcolor: "background.paper" }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            {faqData.Faq.map((faq, index) => (
                                <>
                                    <ListItemButton onClick={(e) => handleOpen(e, index)}>
                                        <ListItemText
                                            disableTypography
                                            primary={
                                                <Typography type="body2" style={{ fontWeight: "bold" }}>
                                                    {faq.Question}
                                                </Typography>
                                            }
                                        />
                                        {index == open ? <ExpandLess /> : <ExpandMore />}
                                    </ListItemButton>
                                    <Collapse in={index == open} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton sx={{ pl: 4 }}>
                                                <Grid container>
                                                    {formatAnswer(faq.Answer).map((element) => (
                                                        <Grid item xs={12}>
                                                            {element === "<gap>" ? (
                                                                <Box sx={{ height: "16px" }} />
                                                            ) : (
                                                                <ListItemText tabindex="0"> {element} </ListItemText>
                                                            )}
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                    <Divider sx={{ margin: "0px 8%" }} />
                                </>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
});

function formatAnswer(answer) {
    const answerArray = answer.split("<br>");
    return answerArray;
}
